import Tag from "./Tag";

export * from "./constants";
export default Tag;
